import React, { useState, useEffect } from 'react';
import apiFetch from '../../../../utils/api';
import Preloader from '../../../../components/Preloader/Preloader';
import Pagination from '../../../../components/Pagination/Pagination';
import './AdminStyles.css';

const AdminPendingWithdrawals = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [acting, setActing] = useState(null);
  const [batchActing, setBatchActing] = useState(false);

  const fetchData = () => {
    setLoading(true);
    apiFetch(`/api/admin/withdrawals/pending?page=${page}`)
      .then(r => r.json()).then(res => { 
        setData(res.withdrawals || []); 
        setTotalPages(res.totalPages || 1);
        setTotalCount(res.totalCount || 0);
        setLoading(false); 
      })
      .catch(() => setLoading(false));
  };
  useEffect(fetchData, [page]);

  const handleAction = async (id, action) => {
    setActing(id);
    try {
      await apiFetch(`/api/admin/withdrawals/${id}/action`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
      });
      fetchData();
    } catch {}
    setActing(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this withdrawal record?')) return;
    setActing(id);
    const res = await apiFetch(`/api/admin/withdrawals/${id}/delete`, { method: 'DELETE' });
    const d = await res.json();
    if (d.success) fetchData();
    setActing(null);
  };

  const handleBatchApprove = async () => {
    if (!window.confirm(`Approve ALL ${totalCount} pending withdrawals?`)) return;
    setBatchActing(true);
    try {
      const res = await apiFetch('/api/admin/withdrawals/batch-action', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'approve' }),
      });
      const d = await res.json();
      if (d.success) fetchData();
    } catch {}
    setBatchActing(false);
  };

  return (
    <div className="admin-page">
      <div className="admin-breadcrumb">🏠 / Admin / Pending Withdrawals</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <h2 className="admin-title" style={{ marginBottom: 0 }}>Pending Withdrawals</h2>
        {data.length > 0 && (
          <button 
            className="admin-btn admin-btn--approve" 
            style={{ padding: '8px 18px', fontSize: 13 }}
            onClick={handleBatchApprove}
            disabled={batchActing}
          >
            {batchActing ? 'Processing...' : `✅ Approve All (${totalCount})`}
          </button>
        )}
      </div>

      <div className="admin-stats-bar" style={{ marginTop: 16 }}>
        <div className="admin-stat-chip orange">⏳ {totalCount} Pending</div>
      </div>
      
      <div className="admin-card">
        <div className="admin-card-body">
          {loading ? (
            <Preloader message="Loading pending withdrawals..." fullScreen={false} />
          ) : data.length === 0 ? (
            <div className="admin-empty">No pending withdrawals.</div>
          ) : (
            <>
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Username</th>
                      <th>Email</th>
                      <th>Amount</th>
                      <th>Description</th>
                      <th>Account #</th>
                      <th>Account Title</th>
                      <th>Team</th>
                      <th>Level</th>
                      <th>Payment Method</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td><strong>{row.username}</strong></td>
                        <td>{row.email}</td>
                        <td><span className="user-balance-chip">Rs. {row.amount}</span></td>
                        <td><span style={{ color: 'var(--awp-accent)', fontWeight: '500' }}>Ads watch earning</span></td>
                        <td>{row.accountNumber || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.accountTitle || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.team || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td><span className="status-badge approved">{row.userLevel}</span></td>
                        <td>{row.paymentMethod || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.createdAt}</td>
                        <td>
                          <div className="admin-actions-row">
                            <button className="admin-btn admin-btn--approve" disabled={acting === row.id} onClick={() => handleAction(row.id, 'approve')}>✅ Approve</button>
                            <button className="admin-btn admin-btn--reject" disabled={acting === row.id} onClick={() => handleAction(row.id, 'reject')}>Reject</button>
                            <button className="admin-btn admin-btn--reject" disabled={acting === row.id} onClick={() => handleDelete(row.id)}>🗑</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination 
                currentPage={page} 
                totalPages={totalPages} 
                onPageChange={setPage} 
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPendingWithdrawals;
